import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatDateLong } from '$lib/lib/formatters';

export interface ApiDownBannerProps {
  // ISO timestamp of the most recent successful fetch — included in the copy
  // so the operator knows how stale the screen is.
  lastSuccessAt: string | null;
}

// Critical state: the dashboard's primary endpoint is unreachable. Renders
// above the page content so existing data stays on screen and the operator
// can still navigate to a run detail page.
export function ApiDownBanner({ lastSuccessAt }: ApiDownBannerProps) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      data-testid="admin-api-down-banner"
      className="flex shrink-0 items-center gap-2 border-b border-danger/30 bg-danger/12 px-4 py-2 text-xs text-danger"
    >
      <AlertTriangle size={14} aria-hidden />
      <span>{t('admin.state.apiDownBanner', { time: formatDateLong(lastSuccessAt) })}</span>
    </div>
  );
}
